"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({
    DEV: {
        dev: true,
        baseUrl: "http://localhost:9123",
    },
    PROD: {
        dev: false,
        baseUrl: "https://wordwave.hosh.it/",
    }
});
